import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installKioskKeyboardListeners } from './utils/kioskMode';

// The redesigned shell is now the production UI on the canonical app/admin
// hosts as well as the retained Shadow rollback/preview hosts.
if (
  window.location.hostname.startsWith('shadow.')
  || window.location.hostname === 'app.intrlock.io'
  || window.location.hostname === 'admin.intrlock.io'
) {
  document.documentElement.classList.add('intrlock-shadow');
}

// Panel-mode listener — when the page is served with ?kiosk=1 it pokes the
// local Intrlock Panel server to show/hide the on-screen keyboard on text
// input focus. No-op in regular browsers.
installKioskKeyboardListeners();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
